export default {
    FP_401: 'FP_401',
    FP_402: 'FP_402',
    FP_406: 'FP_406',
    FP_403: "FP_403",
    FP_400: 'FP_400',
    FP_405: 'FP_405'
  }
